import React, { useEffect, useContext } from 'react';
import { WebSocketContext } from "../WebSocketContext";


function BottomTime() {
    const { lastUpdateTime } = useContext(WebSocketContext);

  return (
    <>
    {  <p className="lastUpdate">Updated @ {lastUpdateTime ? lastUpdateTime.toLocaleString() : "N/A"}</p>}
    </>
  );
}

export default BottomTime;

